/**
 * URL for linking the user to the ECC
 * use alongside useCanSwitchToAdmin hook to check they have access
 */
export const adminUrl = `${window.location.origin}/admin/#/${
  window.location?.search?.includes('toAdmin') ? window.location.search : ''
}`;
